// V6 Block 5 — shared status pill + type badge for unified Agent/VM requests.
// .tsx exports components only (TS-6 rule). isOpenStatus is a helper used by list views.

type PillStyle = { label: string; fg: string; bg: string }

const STATUS_MAP: Record<string, PillStyle> = {
  offen:     { label: 'Offen',      fg: 'var(--st-offline)', bg: 'var(--st-offline-soft)' },
  pending:   { label: 'Offen',      fg: 'var(--st-offline)', bg: 'var(--st-offline-soft)' },
  pruefung:  { label: 'In Prüfung', fg: 'var(--st-idle)',    bg: 'var(--st-idle-soft)' },
  genehmigt: { label: 'Genehmigt',  fg: 'var(--st-online)',  bg: 'var(--st-online-soft)' },
  umgesetzt: { label: 'Umgesetzt',  fg: 'var(--st-online)',  bg: 'var(--st-online-soft)' },
  abgelehnt: { label: 'Abgelehnt',  fg: 'var(--st-idle)',    bg: 'var(--st-idle-soft)' },
}

export function isOpenStatus(status: string): boolean {
  return status === 'offen' || status === 'pending' || status === 'pruefung'
}

export function ReqStatusPill({ status, sm }: { status: string; sm?: boolean }) {
  const m = STATUS_MAP[status] ?? { label: status, fg: 'var(--ink-50)', bg: 'var(--surface-2)' }
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 7,
        padding: sm ? '2px 9px' : '4px 11px', borderRadius: 20,
        fontSize: sm ? 12 : 13, fontWeight: 500, color: m.fg, background: m.bg, whiteSpace: 'nowrap',
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'currentColor' }} />
      {m.label}
    </span>
  )
}

export function RequestTypeBadge({ kind }: { kind: 'agent' | 'vm' }) {
  const isVm = kind === 'vm'
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 6,
        fontSize: 11.5, fontWeight: 600, letterSpacing: '0.02em',
        color: isVm ? 'var(--viridian)' : 'var(--woodland)',
        background: 'var(--surface-2)', border: '1px solid var(--line)',
      }}
    >
      {isVm ? 'VM' : 'Agent'}
    </span>
  )
}
